var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.39674 15.0965C2.43503 14.752 2.45417 14.5797 2.5063 14.4186C2.55255 14.2758 2.6179 14.1398 2.70057 14.0144C2.79375 13.8731 2.91633 13.7506 3.16148 13.5054L14.1667 2.50017C15.0872 1.5797 16.5796 1.5797 17.5001 2.50017C18.4205 3.42065 18.4205 4.91303 17.5001 5.83351L6.49481 16.8387C6.24966 17.0839 6.12709 17.2065 5.98578 17.2996C5.86041 17.3823 5.72445 17.4477 5.58158 17.4939C5.42054 17.546 5.24826 17.5652 4.90368 17.6035L2.08337 17.9168L2.39674 15.0965Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcons);
export default __webpack_public_path__ + "static/media/EditIcons.26ea9c83b2cd106339bbd27707ac30b7.svg";
export { ForwardRef as ReactComponent };